import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ve-copy",
  "use": "icon-ve-copy-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-ve-copy\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M10,8h5.33v6.67h1.34v-8H10ZM7.34,9.33v8H14v-8ZM8.67,8V6a.67.67,0,0,1,.66-.67h8A.67.67,0,0,1,18,6v9.33a.67.67,0,0,1-.67.67h-2v2a.67.67,0,0,1-.67.67h-8A.68.68,0,0,1,6,18V8.67A.67.67,0,0,1,6.67,8Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol